import React, { useState, useEffect, useRef } from 'react';
import OpenAI from 'openai';

const GhostTextCompletion = ({ label, name, value, handleChange, noEdit, className, max }) => {
  const [input, setInput] = useState('');
  const [suggestion, setSuggestion] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const textareaRef = useRef(null);

  const openai = new OpenAI({
    baseURL: 'https://api.deepseek.com',
    apiKey: process.env.REACT_APP_DEEPSEEK_API_KEY,
    dangerouslyAllowBrowser: true
  });

  useEffect(() => {
    const fetchCompletion = async () => {
      if (input.length < 3) {
        setSuggestion('');
        return;
      }

      setIsLoading(true);
      try {
        if(input === ''){
          setInput('');
          return;
        }

        const completion = await openai.chat.completions.create({
          messages: [
            {
              role: "system",
              content: "Predict the most likely continuation of this text.Assume correspondence in an organization, Return only the text that would come next, without repeating the input:"
            },
            { role: "user", content: input }
          ],
          model: "deepseek-chat",
          max_tokens: 15,
          temperature: 0.7
        });

        setSuggestion(completion.choices[0].message.content.trim());
      } catch (error) {
        console.error("Completion error:", error);
        setSuggestion('');
      } finally {
        setIsLoading(false);
      }
    };

    const timer = setTimeout(fetchCompletion, 300);
    return () => clearTimeout(timer);
  }, [input]);

  const handleKeyDown = (e) => {
    // Accept suggestion on Tab or Right Arrow
    if ((e.key === 'Tab' || e.key === 'ArrowRight') && suggestion) {
      e.preventDefault();
      acceptSuggestion();
    }
  };

  const acceptSuggestion = () => {
    setInput(prev => prev + suggestion);
    setSuggestion('');
    // Move cursor to end
    setTimeout(() => {
      textareaRef.current.selectionStart =
        textareaRef.current.selectionEnd = input.length + suggestion.length;
    }, 0);
  };

  return (
    <div className="ghost-container">
      <div className='m-b-10 m-t-10 w-100 m-r-10'>
        <div className='flex'>
          <div className={`label-box-area label-textarea ellipses-over ${className}`}> {label} </div>
          {
            <div className="rel" style={{ height: "40px", border: "1px solid #17621A", width: "100%" }}>

              <textarea
                disabled={noEdit}
                maxLength={max && max}
                autoComplete="off"
                name={name}
                // value={value}
                // onChange={onChange}
                rows={8}
                ref={textareaRef}
                value={input || value}
                onChange={(e) => {setInput(e.target.value); handleChange(e)}}
                onKeyDown={handleKeyDown}
                placeholder="Start typing..."
                // rows={5}
                className="ghost-textarea"
              />

            </div>
          }
        </div>
      </div>


      {suggestion && (
        <div className="ghost-text">
          {input}
          &nbsp;
          <span className="suggestion">{suggestion}</span>
        </div>
      )}

      {isLoading && (
        <div className="loading-indicator">
          <div className="spinner"></div>
        </div>
      )}
    </div>
  );
};

export default GhostTextCompletion;